<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="title">
<p class="bk">The Drop Edge of Yonder</p>
<p class="bk1">An Alafair Tucker Mystery</p>
<p class="bkau">Donis Casey</p>
<p class="bkau1"><a class="calibre2" href="http://www.doniscasey.com" target="_blank">www.doniscasey.com</a></p>
<p class="bkpub">Poisoned Pen Press</p>
<p class="bkpub"><img alt="" class="calibre3" src="OEBPS/ppp-logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-drop002.vue?d8a782ec